import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  ConfirmModalSimple,
  ConfirmModalSimpleProps,
} from '../../../../components/ConfirmModalSimple';

type Props = Omit<ConfirmModalSimpleProps, 'message'>;

type ExpenseGroupDeleteProps = Omit<ConfirmModalSimpleProps, 'message'> & {
  expenseGroupName?: string;
  childExpenseCount?: number;
};

export const ExpenseDeleteConfirmation = ({ ...restProps }: Props) => {
  const { t } = useTranslation();

  const message = t('expenses.deleteModal.confirmText');

  return <ConfirmModalSimple {...restProps} message={message} />;
};

export const ExpenseGroupDeleteConfirmation = ({
  expenseGroupName,
  childExpenseCount,
  ...restProps
}: ExpenseGroupDeleteProps) => {
  const { t } = useTranslation();

  const message = t('expenses.deleteExpenseGroupModal.confirmText');

  return <ConfirmModalSimple {...restProps} message={message} />;
};
